(function($, App, Utils, Components, Pages) {
  'use strict';

  var Log = new Logger('Test');

  Pages.create('Test', {

    init: function() {

      Utils.Ajax.on(Utils.Ajax.Events.Before, function(e){
        Log.info("Ajax before", arguments);
      });
      Utils.Ajax.on(Utils.Ajax.Events.Success, function(e, data, xhr){
        Log.info("Ajax success", arguments);
      });
      Utils.Ajax.on(Utils.Ajax.Events.Error, function(e, xhr){
        Log.info("Ajax error generic", xhr);
      });
      Utils.Ajax.on(Utils.Ajax.Events.Error + ":404", function(e, xhr){
        Log.info("Ajax error", xhr);
      });
      Utils.Ajax.on(Utils.Ajax.Events.Completed, function(e){
        Log.info("Ajax completed", arguments);
      });


      Utils.on(Utils.Events.Init, function() {
        Log.info("All Utilities has been loaded");
      });


      setTimeout(function(){
        $.get("test.html");
      }, 1000);

    }

  });

})(jQuery,
  window.App,
  window.App.Utils,
  window.App.Components,
  window.App.Pages
);
